import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutePath } from 'app/routing/routes';
import { UserInfo } from 'app/_models';
import { AuthService } from 'app/_services/auth.service';
import { UserService } from 'app/_services/user.service';

@Component({
    selector: 'app-sidebar-user-area',
    templateUrl: './sidebar-user-area.component.html',
    styleUrls: ['./sidebar-user-area.component.scss'],
})
export class SidebarUserAreaComponent implements OnInit {
    user: UserInfo = null;
    role: string;

    constructor(private router: Router, private userService: UserService, private authService: AuthService) {
        this.user = this.userService.UserValue;
        this.role = this.user?.CurrentRole.roleName;
    }

    ngOnInit(): void {}

    login(): void {
        this.router.navigate([RoutePath.Login]);
    }

    logout(): void {
        this.authService.Logout();
    }
}
